export type GetTicketsRequest = {
  pageSize: number;
  currentPage: number;
  status?: TicketStatus | null;
  fromDate?: Date;
  toDate?: Date;
  sort?: string;
  order?: string;
  search?: string;
};

export type GetModeratorTicketsRequest = GetTicketsRequest & {
  moderatorId: string;
};

export enum TicketStatus {
  ACTIVE = "ACTIVE",
  CLOSED = "CLOSED",
}

export type AddMessageToTicket = {
  text: string;
};

export type ChangeTicketStatus = {
  status: TicketStatus;
};
